import { getHtmlElement, getIframeElementWithDefaultStyles } from '../../utils';
import windowTarget from '../../utils/windowTarget';

/**
 * Loader for las flows rendered from the loader page deployed alongside the
 * sdk (src/las/loader.html, copied to s3 by build/moveBuild.sh), so showing
 * a loading state doesn't depend on the connect frame.
 */
let loaderIframe: HTMLIFrameElement | null = null;
let loaderLoadPromise: Promise<void> | null = null;
let loaderVisible = false;

/**
 * Injects the loader iframe (hidden) so the page is already loaded by the
 * time a flow needs it; called from the ScLoan constructor to avoid any
 * delay when the loader is first shown.
 */
export const injectLoaderFrame = () => {
  if (loaderLoadPromise) return loaderLoadPromise;
  const newIframe = getIframeElementWithDefaultStyles();
  loaderIframe = newIframe;
  // stay below the gw client frame (+2147483647) so the client covers the loader once visible
  loaderIframe.style.zIndex = '+2147483646';
  loaderIframe.classList.add('scdk-las-loader-frame');
  loaderLoadPromise = new Promise((resolve) => {
    newIframe.onload = () => resolve();
  });
  loaderIframe.setAttribute('src', LAS_LOADER_URL);
  const referenceElement = getHtmlElement(windowTarget.elementOrSelector);
  referenceElement.appendChild(loaderIframe);
  return loaderLoadPromise;
};

export const showLoader = async () => {
  loaderVisible = true;
  // wait for the loader page load to avoid flashing an empty frame
  await injectLoaderFrame();
  // skip if the loader was hidden while the page was still loading
  if (!loaderVisible) return;
  if (!loaderIframe) return;
  // The loader iframe always uses the light scheme to preserve transparency.
  loaderIframe.style.colorScheme = 'light';
  loaderIframe.style.visibility = 'unset';
  loaderIframe.style.display = 'unset';
};

export const hideLoader = () => {
  loaderVisible = false;
  if (!loaderIframe) return;
  loaderIframe.style.visibility = 'hidden';
  loaderIframe.style.display = 'none';
};
